import { type VisitationPending } from '@reliance/types/models/Visitation';
import { type PaginatedResponse } from '@reliance/types/responses/PaginatedResponse';
import { type ApiService } from '../types/ApiService';

export const visitationPending = (siteApi: ApiService) => ({
  index: (params?: object): Promise<PaginatedResponse<VisitationPending>> => {
    return siteApi.get('/visitation-pending', { params });
  },
  put: (id: number, note: string, timeLimit: number) => {
    return siteApi.put('/visitation-pending', {
      id,
      note,
      timeLimit,
    });
  },
  approve: (id: number, note: string, timeLimit: number) => {
    return siteApi.put('/visitation-pending/approve', {
      id,
      note,
      timeLimit,
    });
  },
  reject: (id: number, note: string) => {
    return siteApi.put('/visitation-pending/reject', {
      id,
      note,
    });
  },
});
